import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";
import { AlertCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordPage() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) return setError("New passwords do not match");
    if (next.length < 6) return setError("New password must be at least 6 characters");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser({ ...user, must_change_password: false });
      toast.success("Password changed");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="max-w-md w-full">
        <CardContent className="p-8">
          <h2 className="heading text-2xl font-bold text-slate-900">Change password</h2>
          {user?.must_change_password && (
            <div className="mt-3 flex items-start gap-2 bg-amber-50 border border-amber-200 rounded px-3 py-2 text-sm text-amber-800">
              <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
              <span>Your administrator issued a temporary password. Please change it to continue.</span>
            </div>
          )}
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Current password</Label><Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" /></div>
            <div><Label>New password</Label><Input type="password" required value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" /></div>
            <div><Label>Confirm new password</Label><Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" /></div>
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="cp-submit">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null} Change password
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
